// Shared config for the /join-team page components.

export const JOIN_PROGRAMS = [
  {
    slug: "wellness-plan",
    image: "/images/program-wellness.png",
    label: "IRS Section 125 compliant",
    title: "Preventative Wellness Plan",
    body: "AI-powered wellness programs that reduce claims and unlock payroll tax savings.",
  },
  {
    slug: "tariff-refund",
    image: "/images/program-tariff.png",
    label: "Recover overpaid tariffs",
    title: "Tariff Refund Program",
    body: "Recover tariffs ruled unconstitutional — we handle the claims process.",
  },
  {
    slug: "rd-tax-credits",
    image: "/images/program-rnd.png",
    label: "Federal tax credits",
    title: "R&D Tax Credits",
    body: "Maximize credits for qualifying R&D activities in software, products, and processes.",
  },
  {
    slug: "power-plan",
    image: "/images/program-power.png",
    label: "Property revenue asset",
    title: "SmartEdge Power Plan",
    body: "Turn your clients' properties into revenue with Tesla Supercharger installations.",
  },
];

export const scrollToId = (id) => (e) => {
  if (e) e.preventDefault();
  document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
};
